import qs from 'qs';

import pathsManifest from '../pathsManifest';
import trackAuthRedirect from '../redirectTracker';
import brandConstants from '../constants/brandConstants';

function getRouteParam(routing, param) {
  if (!routing || !routing.location) {
    return '';
  }

  if (param === 'pathname') {
    return routing.location.pathname;
  } else if (param === 'search') {
    return routing.location.search;
  }
}

function addIsZillowApp(otherParams, isZillowApp) {
  if (!isZillowApp) {
    return otherParams;
  }

  // location.search is prepended with a '?'
  const params = qs.parse(otherParams, { ignoreQueryPrefix: true });
  params.isZillowApp = true;
  // keeping the '?' that location.search was prepended with
  return qs.stringify(params, { addQueryPrefix: true });
}

function shouldRedirectToLogin({
  loggedIn,
  requireStrongAuthentication,
  hasStrongAuthentication,
  isTwoFactorAuthEnabled,
  isTwoFactorAuthenticated,
  impersonatorEmail,
  impersonatorUserToken,
}) {
  const isImpersonator = impersonatorEmail && impersonatorUserToken;
  return (
    !loggedIn ||
    (!isImpersonator && requireStrongAuthentication && !hasStrongAuthentication) ||
    (!isImpersonator && requireStrongAuthentication && isTwoFactorAuthEnabled && !isTwoFactorAuthenticated)
  );
}

function getRedirectToIfNeeded({
  brand,
  routing,
  loggedIn,
  requireStrongAuthentication,
  hasStrongAuthentication,
  isTwoFactorAuthEnabled,
  isTwoFactorAuthenticated,
  impersonatorEmail,
  impersonatorUserToken,
  isInWebView,
  zillowCustomLoginPagePath = '',
}) {
  const toUrl = getRouteParam(routing, 'pathname');
  const otherParams = getRouteParam(routing, 'search');
  const isZillowApp = isInWebView && brand === brandConstants.ZILLOW_BRAND;
  let redirectTo = false;

  if (!loggedIn) {
    // zillow native apps use a webview
    if (isZillowApp) {
      redirectTo = pathsManifest[brand].nativeAppSignInPage(toUrl, otherParams);
    } else {
      redirectTo = pathsManifest[brand].signInPage(toUrl, otherParams, zillowCustomLoginPagePath);
    }
  } else if (requireStrongAuthentication && !hasStrongAuthentication) {
    if (impersonatorEmail && impersonatorUserToken) {
      // impersonators don't have to redirect
      redirectTo = false;
    } else {
      // strong password required
      const otherParamsWithIsZillowApp = addIsZillowApp(otherParams, isZillowApp);
      redirectTo = pathsManifest[brand].passwordResetPage(toUrl, otherParamsWithIsZillowApp);
    }
  } else if (requireStrongAuthentication && isTwoFactorAuthEnabled) {
    if (impersonatorEmail && impersonatorUserToken) {
      redirectTo = false;
    } else if (!isTwoFactorAuthenticated) {
      redirectTo = pathsManifest[brand].twoFactorAuthPage(toUrl, otherParams);
    }
  }

  return redirectTo;
}

function handleRedirectTo({ userToken, loggedIn, email, hasStrongAuthentication }, redirectTo) {
  trackAuthRedirect({
    userToken,
    loggedIn,
    email,
    hasStrongAuthentication,
    redirectTo,
  });

  try {
    window.stop();
  } catch (exception) {
    document.execCommand('Stop');
  }
  window.location.replace(redirectTo);
}

export { getRouteParam, shouldRedirectToLogin, getRedirectToIfNeeded, handleRedirectTo };
